<template>
  <div class="category-container">
    <Loading v-if="$store.state.modalStore.isLoading" />
    <div
      class="modal-category-wrapper"
      @mouseenter="overlayOn"
      @mouseleave="overlayOff"
    >
      <div class="category-content">
        <div class="category-parent-wrapper">
          <div v-for="list in listUsaha" class="w-full">
            <div
              :class="
                `btn-kbli-parent cursor-pointer ${
                  list.id == currentParentId ? 'btn-kbli-parent__active' : ''
                }`
              "
              @click="changeFilter(list.id, list.name)"
            >
              <span>
                <img
                  :src="require(`~/assets/img/icons/${list.id}.png`)"
                  alt=""
                />
              </span>
              {{ list.name }}
            </div>
          </div>
        </div>
        <div class="category-child-wrapper">
          <KbliList
            :parentId="currentParentId"
            :parentName="currentParentName"
          />
        </div>
      </div>
      <div class="category-tag">
        <div class="tag-container">
          <ResultBar
            :data="this.$store.state.searchStore.choosedKbli"
            :desc="'desc'"
            :onClick="id => kbliRemove(id)"
            :vertical="true"
            v-if="this.$store.state.searchStore.choosedKbli.length > 0"
          />
          <BtnIcons
            :path="'icon-search.png'"
            :title="'Tampilkan'"
            :position="true"
            :onClick="onSearch"
          />
        </div>
      </div>
    </div>
    <div class="container-blur" v-if="$store.state.overlayOpacity == 1"></div>
  </div>
</template>
<script>
import ResultBar from '@/components/Organism/ResultBar.vue'
export default {
  components: {
    Loading: () => import('@/components/utils/Loading'),
    BtnIcons: () => import('@/components/Atoms/BtnIcons'),
    KbliList: () => import('@/components/Organism/KbliList'),
    ResultBar,
  },
  data() {
    return {
      forceReload: true,
      currentParentId: 0,
      currentParentName: '',
      listUsaha: [
        {
          name: 'Pertanian, Kehutanan, dan Perikanan',
          id: '1',
          sub: [
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
          ],
        },
        {
          name: 'Pertambangan dan Penggalian',
          id: '2',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Industri Pengolahan',
          id: '3',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Pengadaan Listrik, Gas, Uap/Air Panas dan Udara',
          id: '4',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Treatmen Air, Treatment Air Limbah, Treatment Udara',
          id: '5',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Konstruksi',
          id: '6',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Perdagangan Besar Dan Eceran, Reparasi dan Perbaikan',
          id: '7',
          sub: [
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
          ],
        },
        {
          name: 'Pengangkutan dan Pergudangan',
          id: '8',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Penyediaan Akomodasi dan Penyediaan Makanan dan Minuman',
          id: '9',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Informasi dan Komunikasi',
          id: '10',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Keuangan dan Asuransi',
          id: '11',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Real Estat',
          id: '12',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Profesional, Ilmiah dan Teknis',
          id: '13',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Penyewaan dan Sewa Guna Usaha dan Jasa',
          id: '14',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Administrasi Pemerintahan Pusat',
          id: '15',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Pendidikan',
          id: '16',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Kesehatan Manusia dan Aktivitas Mesin',
          id: '17',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Kesenian, Hiburan dan Rekreasi',
          id: '18',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Jasa Lainnya',
          id: '19',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name:
            'Aktivitas Rumah Tangga Sebagai Pemberi Kerja kepada masyarakat',
          id: '20',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Badan International dan Nasional',
          id: '21',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
      ],
      overlayOpacity: 0,
      modalVisibility: 'visible',
    }
  },
  computed: {
    choosedKbli: {
      get: function() {
        return this.$store.state.searchStore.choosedKbli
      },
    },
  },
  methods: {
    overlayOn() {
      this.modalVisibility = 'visible'
      this.$store.commit('setData', {
        name: 'overlayOpacity',
        value: 1,
      })
    },
    overlayOff() {
      this.$store.commit('setData', {
        name: 'overlayOpacity',
        value: 0,
      })
      this.modalVisibility = 'hidden'
    },
    changeFilter(id, name) {
      this.currentParentId = id
      this.currentParentName = name
    },
    kbliRemove(id) {
      let data = this.$store.state.searchStore.choosedKbli

      let newData = data.filter(i => i.id != id)

      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedKbli',
        value: newData,
      })
    },
    async onSearch() {
      let query = {
        vendorName: '',
        location: '',
        status: '',
        negara: '',
        prov: '',
        kota: '',
        kec: '',
        kel: '',
        tambang: '',
        sio: '',
        k3l: '',
        kplh: '',
        poStart: '',
        poEnd: '',
        eventStart: '',
        eventEnd: '',
        spmStart: '',
        spmEnd: '',
        sioStart: '',
        sioEnd: '',
        k3lStart: '',
        k3lEnd: '',
        kplhStart: '',
        kplhEnd: '',
        gradeStart: '',
        gradeEnd: '',
        csiStart: '',
        csiEnd: '',
        k3lScore: '',
        kplhScore: '',
        kbliSub:
          this.choosedKbli && this.choosedKbli.length > 0
            ? this.paramsFormatter(
                'kbli_sub',
                this.choosedKbli.map(item => {
                  return item.id
                })
              )
            : '',
        kbliParent: '',
        iujp: '',
        ijuptl: '',
        sbujk: '',
        inubbm: '',
        siupal: '',
      }

      // await this.$store.commit('modalStore/SET_MODAL_LEVEL1', false)
      await this.$store.commit('modalStore/closeModal', {
        name: 'category',
      })
      await this.$store.commit('level1/GET_VENDOR', { query })
      await this.$store.commit('modalStore/closeModal', {
        name: 'advanceSearch',
      })

      if (this.$route.path !== '/search-result') {
        await this.$router.push('search-result')
      }
    },
  },
}
</script>
